(() => {
  if (window.customElements.get('announcement-countdown-v2')) return;

  class AnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      this.endTime = Date.parse(this.dataset.end || '');
      if (!Number.isFinite(this.endTime)) {
        this.hidden = true;
        return;
      }

      this.days = this.querySelector('[data-countdown-days]');
      this.daysUnit = this.querySelector('[data-countdown-days-unit]');
      this.daysSeparator = this.querySelector('[data-countdown-days-separator]');
      this.hours = this.querySelector('[data-countdown-hours]');
      this.minutes = this.querySelector('[data-countdown-minutes]');
      this.seconds = this.querySelector('[data-countdown-seconds]');
      this.update();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }

    update() {
      const remaining = Math.max(0, this.endTime - Date.now());
      this.hidden = false;
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (this.days) this.days.textContent = String(days).padStart(2, '0');
      if (this.daysUnit) this.daysUnit.hidden = days === 0;
      if (this.daysSeparator) this.daysSeparator.hidden = days === 0;
      if (this.hours) this.hours.textContent = String(hours).padStart(2, '0');
      if (this.minutes) this.minutes.textContent = String(minutes).padStart(2, '0');
      if (this.seconds) this.seconds.textContent = String(seconds).padStart(2, '0');

      this.setAttribute(
        'aria-label',
        `${days} dage, ${hours} timer, ${minutes} minutter og ${seconds} sekunder tilbage`
      );

      if (remaining <= 0) {
        const expiredText = this.dataset.expiredText?.trim();
        if (expiredText) {
          this.textContent = expiredText;
          this.setAttribute('aria-label', expiredText);
        } else {
          this.hidden = true;
        }
        return;
      }

      this.timer = window.setTimeout(() => this.update(), 1000 - (Date.now() % 1000));
    }

  }

  window.customElements.define('announcement-countdown-v2', AnnouncementCountdown);
})();
